export default {
  common: {
    chiller: "Enfriador",
    chilledWaterPump: "Bomba de agua fría",
    coolingTower: "Torre de enfriamiento",
    nextStep: "Siguiente paso",
    previousStep: "Paso anterior",
    objective: "Objetivo",
    preRetrofit: "Preactualización",
    postRetrofit: "Postactualización",
    retrofitSetup: "Configuración de modernización",
    equipmentRated: "Equipo y configuración",
    equipmentConfig: "Équipement et configuration",
    retrofitSummary: "Resumen de modernización",
    cwp: "CWP",
    condenderWaterPump: "Bomba de agua condensada",
    chwp: "CHWP",
    ct: "CT",
    other: "Otro",
    otherEquipment: "Otro equipo",
    chillerOneNos: "Enfriador (1 uds.)",
    condenderWaterPumpOneNos: "Bomba de agua condensada (1 uds.)",
    chilledWaterPumpOneNos: "Bomba de agua fría (1 uds.)",
    coolingTowerFanOneNos: "Torre de enfriamiento (1 uds.)",
    controlOptimization: "Optimización del control",
    commonHeader: "Cabecera común",
    dedicatedOneOnOne: "Dedicado (1-1)",
    pleaseInput: "Por favor ingrese",
    pleaseEnterHere: "Por favor ingrese aquí",
    cancel: "Cancelar",
    confirm: "Confirmar",
    years: "Años",
    noProjectInfo: "No hay información del proyecto",

    pleaseInputData: "Por favor, introduzca los datos",
    systemOptionRequired: "Se requieren opciones del sistema",
    proposedEquipmentRequired: "Se necesitan equipos recomendados",

    profileEquipmentSetting: "Configuración del equipo del perfil",
    Total: "Total"
  },
  objective: {
    projectObjective: "Objetivo del proyecto",
    chillerEfficiency: "Eficiencia del enfriador",
    chillerPlantEfficiency: "Eficiencia de la planta de enfriadores",
    heatingEfficiency: "Eficiencia de calefacción",
    heatingPlantEfficiency: "Eficiencia de la planta de calefacción",
    chillerHeatingEfficiency: "Eficiencia de calefacción del enfriador",
    pleaseSelectAProjectObjective: "Por favor seleccione un objetivo del proyecto",
    oneOnOne: "( 1 - 1 )",
    oneOnOneOrPlant: "( 1 - 1 ) o Planta",
    projectName: "Nombre del proyecto",
    doYouWantSave: "¿Desea guardar sus datos en la nube antes de cerrar?",
    start: "Comenzar",
    quickNavigation: "Navegación rápida",
    mainMenu: "Menú principal",

    establishBaseline: "Establecer una base de referencia (Pre-adaptación)",
    profile: "Perfil",
    siteObservation: "Observación in situ",
    equipmentSpecification: "Especificaciones del equipo",
    baselineInput: "Entrada de base",
    summary: "Resumen",
    generateReport: "Generar informes",

    finalizeYourProposal: "Opción de soluciones (Retrofitación posterior)",
    finalizeAnalysis: "Finalizar el análisis",
    retrofitSetup: "Configuración de modificación",
    equipmentConfig: "Équipement et configuration",
    financialAnalysis: "Análisis financiero",
    proposedConfig: "Aonfiguración propuesta",
    systemOption: "Opción del sistema",
    ProfileEquipment: "Perfil y equipos",
    baselinePreview: "Vista previa de la línea de base",
    profileEquipment: "Equipo de perfil",
    selectProposedEquipments: "Seleccione los equipos propuestos",
    pleaseSelectEquipments: "Por favor seleccione equipos.",

    clusterSetting: "Configuración del clúster",
    generateOption: "Generar opción",

    baselineConfig: "Configuración de línea base",
    monthlyBaseline: "Base mensual"
  },
  setup: {
    systemOption: "Opción del sistema",
    chillerOnly: "Solo enfriador",
    chillerWithAssociatedEquipment: "Enfriador con equipo asociado",
    controlOnly: "Solo control",
    proposedLayout: "Diseño propuesto",
    series: "Serie",
    parallel: "Paralelo",
    proposedEquipment: "Equipo propuesto"
  },
  rated: {
    newEquipment: "Nuevo equipo",
    ratedInputPower: "Potencia de entrada nominal",
    ratedCoolingCapacity: "Capacidad de refrigeración nominal",
    chillerLabel: "Etiqueta del enfriador",
    type: "Tipo",
    chillerBrandModel: "Marca y modelo del enfriador",
    yearInstalled: "Año de instalación",
    ratedDesignFlowRate: "Caudal de diseño nominal",
    pressureHead: "Altura de presión",
    vfd: "¿¿ está instalada la unidad de conversión de frecuencia?",
    yes: "Sí",
    no: "No",
    noofFansCT: "Cantidad de ventiladores/CT",
    equipmentLabel: "Etiqueta del equipo",
    category: "Categoría",
    brand: "Marca",
    otherEquipment: "Otro equipo",
    inputEcatPerformanceData: "Introducir datos de rendimiento de Ecat",
    load: "Carga",
    coolingLoad: "Carga de refrigeración",
    inputPower: "Potencia de entrada",
    chillerWaterPumpLabel: "Etiqueta de la bomba de agua fría",
    ratedMotorFrequency: "Frecuencia nominal del motor",
    minimumMotorFrequency: "Frecuencia mínima del motor",
    motor: "Motor",
    applicableChiller: "Enfriador aplicable",
    condenserWaterPumpLabel: "Etiqueta de la bomba de agua condensada",
    coolingTowerLabel: "Etiqueta de la torre de enfriamiento",
    ratedFanFrequency: "Frecuencia nominal del ventilador",
    minimumFanFrequency: "Frecuencia mínima del ventilador",
    totalRatedFanPowerPerCT: "Potencia total nominal del ventilador por CT",
    heatRejectionCapacityPerCT: "Capacidad de rechazo de calor por CT",
    chillerLabelRequired: "Se requiere la etiqueta del enfriador",
    yellowBlockRequired: "Se requiere el bloque amarillo",
    labelRequired: "Se requiere etiqueta",
    maximumQuantity: "Cantidad máxima",

    chilledWaterSupplyTemp: "Temperatura de suministro de agua refrigerada",
    outdoorAirTemp: "Temperatura del aire exterior",

    condenserWaterSupplyTemp: "Temperatura de suministro de agua del condensador",

    singleChillerSellingPrice: "Precio de venta de refrigerador único",

    singleCHWPSellingPrice: "Precio de venta CHWP único",
    singleCWPSellingPrice: "Precio de venta CWP único",
    singleCTSellingPrice: "Precio de venta CT único",

    singlePrice: "Precio de venta único"
  },
  summary: {
    chooleYourPreference: "Elija su preferencia",
    higherEfficiencyImprovement: "Mejorar la eficiencia",
    lowerInvestment: "Menor inversión",
    higherCostSaving: "Mayor ahorro de costos",
    shorterPaybackPeriod: "Período de recuperación más corto",
    option: "Opción",
    efficiencyImprovement: "Mejora de eficiencia",
    returnOnInvestment: "Retorno de la inversión",
    costSavingsPerYear: "Ahorros de costos por año",
    paybackPeriod: "Período de recuperación",
    optionDetails: "Detalles de la opción",
    postRetrofitEfficiency: "Eficiencia posterior a la modernización",
    totalEnergySavingsPerYear: "Ahorro total de energía por año",
    investmentAnalysis: "Análisis de inversión (reales)",
    capex: "CAPEX",
    sellingPrice: "Precio de venta",
    OverallProjectPrice: "Precio total del proyecto",
    chillerCooling: "Enfriador-refrigeración",
    chillerHeatPump: "Enfriador-bomba de calor",
    calculate: "Calcular",
    proposedConfig: "Configuración propuesta",
    projectIntroduction: "Introducción al proyecto",
    assumptions: "Supuestos",
    chillerPlant: "Planta de enfriadores",
    chillerPlantConfig: "Configuración de la planta de enfriadores",
    peakBuildingCoolingLoad: "Carga de refrigeración máxima del edificio",
    designChilledWaterSupplyTemp: "Temperatura de suministro de agua fría de diseño",
    designCondenserWaterSupplyTemp: "Temperatura de suministro de agua condensada de diseño",
    energyConservationMeasures: "Medidas de conservación de energía",
    pumpingConfig: "Configuración de bombeo",
    designFlowRate: "Caudal de diseño",
    designPressureHead: "Altura de presión de diseño",
    vfdFitted: "VFD instalado",
    chillerConfig: "Configuración del enfriador",
    condenserWaterPump: "Bomba de agua condensada",
    coolingTowerConfig: "Configuración de la torre de enfriamiento",
    heatRejectionCapacity: "Capacidad de rechazo de calor",
    designCoolingTowerApproach: "Enfoque de diseño de la torre de enfriamiento",
    generateReport: "Generar informe",
    confirmCalculation: "Confirmar cálculo",
    doYouNeedCalculationAgain: "El resultado del cálculo ya existe. ¿Necesita recalcular?",
    recalculate: "Recalcular",
    coolingTower: "Torre de enfriamiento",
    chiller: "Enfriador",
    chilledWaterPump: "Bomba de agua fría",
    fillValidNumericalValue: "Rellene un valor válido",

    runningNumber: "Número de ejecución"
  },
  profileMap: {
    associatedCT: "Mapeo de la torre de enfriamiento",
    associatedCWP: "Mapeo CWP",
    associatedCHWP: "Mapeo CHWP",
    profileId: "ID del perfil",
    donotNeedmanipulate: "En modo automático, no necesita manipular el archivo de configuración.",

    automatic: "Automático",
    manual: "Manual",
    pathAndMethod: "Caminos y métodos",
    months: "Mes",
    running: "Correr",
    daysPerMonth: "Día / mes",
    chiller: "Enfriador"
  }
  // reportFocusDlg: {
  //   selectCustomerReportingFocus: "Seleccionar el enfoque del informe para el cliente",
  //   roiLedSummary: "Resumen orientado al ROI",
  //   roiLedSummaryDetails: "Utilícelo cuando se disponga de datos de inversión, ahorro y período de recuperación.",
  //   efficiencyImprovementLedSummary: "Resumen orientado a la mejora de la eficiencia",
  //   efficiencyImprovementLedSummaryDetails:
  //     "Utilícelo cuando la decisión se base principalmente en la mejora de la eficiencia energética o cuando los datos de ROI no estén disponibles o no sean relevantes."
  // }
}



// WEBPACK FOOTER //
// ./src/locale/post/es.js